import { useFrame } from "@react-three/fiber";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { BufferAttribute, IcosahedronGeometry, Vector3, VertexColors } from "three";
import { darkerGrey, darkGrey, grey, pink } from "../../shared/colours";
import { ThemeModeContext } from "../../shared/Theme";

const AnimationCymplifyLogo = (props) => {

	const themeModeContext = useContext(ThemeModeContext);
	
	let [ shouldRenderDots, setShouldRenderDots ] = useState(false);
	
	const shapeContainer = useRef();
	const shape = useRef();
	const dots = useRef();
	
	const lineColour = themeModeContext.themeMode === "light"? grey : darkGrey;
	
	useFrame((state, delta) => {
		if (!shouldRenderDots) return;
		
		shapeContainer.current.rotation.x += 0.1 * delta;
		shapeContainer.current.rotation.y += 0.1 * delta;
		// dots.current.rotation.x += 0.1 * delta;
		// dots.current.rotation.y += 0.1 * delta;
	});
	
	useEffect(() => {
		setTimeout(() => {
			setShouldRenderDots(true);
		}, 100);
	}, [])
	
	const Dots = (props) => {
		if (!props.shouldRender) return <React.Fragment/>
		
		let vertices = [];
		
		// const shapeObject = new IcosahedronGeometry(1, 2);		
		const positionAttribute = shape.current.geometry.getAttribute("position");
		
		for (let i = 0; i < positionAttribute.count; i++) {
			const point = new Vector3();
			point.fromBufferAttribute(positionAttribute, i); 
			vertices.push(point);
		}
		
		var positions = new Float32Array(vertices.length * 3);
		for (var i = 0, l = vertices.length; i < l; i++) {
			vertices[i].toArray(positions, i * 3);
		}
		
		const pointData = new BufferAttribute(positions, 3);
		
		return (
			<points ref={dots} scale={3}>
				<bufferGeometry>
					<bufferAttribute attach={"attributes-position"} {...pointData} />
				</bufferGeometry>
				<pointsMaterial
					size={0.1}
					color={pink}
				/>
			</points>
		);
	}
	
	return (
		<React.Fragment>
			<mesh ref={shapeContainer}>
				<Dots shouldRender={shouldRenderDots}/>
				<mesh ref={shape} scale={3}>
					<icosahedronGeometry args={[1, 2]}/>
					<meshStandardMaterial wireframe color={lineColour} />
				</mesh>
			</mesh>
		</React.Fragment>
	);

}

export default AnimationCymplifyLogo;